import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=da12927e&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=da12927e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports